
import { pathOr } from "ramda";

import { metaColourMixin } from "~/mixins";
import { hasSingleSize, groupByProp } from "~/utils";

export default {
  mixins: [metaColourMixin],

  props: {
    tiles: { type: Array, required: true },
    label: { type: String, required: true },
    selectedTile: { type: String, required: true },
    variants: { type: Array, required: true },
    handleVariantSelect: { type: Function, required: true },
    selectedVariant: { type: Object, required: true },
  },

  computed: {
    isSingleSizeSelected() {
      const option = pathOr({}, ["selectedVariant", "selectedOptions"], this);
      return hasSingleSize(option);
    },
    variantsById() {
      return groupByProp("id")(this.variants);
    },
    pdpTiles() {
      return this.tiles.filter(tile => tile.targetVariantId !== null);
    },
  },

  methods: {
    handleSelect(tileName, $event) {
      this.handleVariantSelect($event);
    },
  },
};
